import React from 'react';

import { ArrangementGroupsOverviewRoute } from './OverviewRoute';
import { ValleyBankTemplate } from 'valleyBank/domains/page/ui/ValleyBankTemplate';

export const ArrangmentGroupsRoutes = () => {
  return (
    <ValleyBankTemplate canToggleDataSource>
      <ArrangementGroupsOverviewRoute />
    </ValleyBankTemplate>
  );
};
